import { useList } from "@refinedev/core";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { formattedDate, timeFromNow } from "utility/time";
import { Shape } from "types";

type TLogListProps = {
  currentCanvas: any;
};

export const LogList = ({ currentCanvas }: TLogListProps) => {
  const { data } = useList<Shape>({
    resource: "shapes",
    liveMode: "auto",
    meta: {
      select: "*",
    },
    filters: [
      {
        field: "canvas_id",
        operator: "eq",
        value: currentCanvas.id,
      },
    ],
    sorters: [
      {
        field: "created_at",
        order: "desc",
      },
    ],
    pagination: {
      mode: "off",
    },
  });

  const shapes = data?.data;

  return (
    <List>
      {shapes?.length > 0 ? (
        shapes?.map((item: any) => (
          <ListItem key={item?.created_at}>
            <ListItemAvatar style={{ marginBottom: "auto", paddingTop: "8px" }}>
              <Avatar src={item?.author?.user_metadata?.avatar_url} />
            </ListItemAvatar>
            <ListItemText>
              <Typography variant="body1" style={{ fontSize: "12px" }}>
                <strong>{item?.user_id}</strong>
                {` created a ${item.data.type} on canvas: `}
                <strong>{`${item?.canvas_id} `}</strong>
                <br />
                <span style={{ fontSize: "10px", color: "#9c9c9c" }}>
                  {`${formattedDate(item.created_at)} - ${timeFromNow(
                    item.created_at
                  )}`}
                </span>
              </Typography>
              <hr />
            </ListItemText>
          </ListItem>
        ))
      ) : (
        <Typography
          variant="body1"
          color="GrayText"
          fontWeight="semibold"
          textAlign="center"
          mx="auto"
        >
          No activity in this canvas.
        </Typography>
      )}
    </List>
  );
};
